export interface ITransactionCommon {
    to?: string;
    from?: string;
    nonce?: string;
    gas?: string;
    gasPrice?: string;
    data?: string;
    value?: string;
    chainId?: number;
}